import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import i18n from "./src/i18n";
import { I18nextProvider } from "react-i18next";``
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GlobalStyles from "./src/styles/global";

// Wrapper component that handles language changes
const LanguageWrapper = ({ children }: { children: React.ReactNode }) => {
  React.useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      document.documentElement.lang = lng;
      document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    };

    // Set initial language
    handleLanguageChange(i18n.language);

    // Listen for language changes
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  return <>{children}</>;
};

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => {
  return (
    <I18nextProvider i18n={i18n}>
      <GlobalStyles />
      <LanguageWrapper>{element}</LanguageWrapper>
    </I18nextProvider>
  );
};
